import { useMemo } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import { ReviewCardProps } from '../components/Packages/ReviewCard'
import { PurchaseCardProps } from '../components/Packages/PurchaseCard'

// @TODO: Cleanup the `variant` arg as it is not used anymore
export default function useZipjobPackages(variant: string | null = null): {
  reviewPackage: ReviewCardProps
  standardPackage: PurchaseCardProps
  proPackage: PurchaseCardProps
  elitePackage: PurchaseCardProps
  executivePackage: PurchaseCardProps
  executiveExpandedPackage: PurchaseCardProps
} {
  const { i18n } = useTranslation()

  const tRef = 'zipjob-purchase-footer'

  const reviewPackage: ReviewCardProps = useMemo(
    () => ({
      packageName: i18n.t(`${tRef}.packages.free.name`),
      packageDescription: i18n.t(`${tRef}.packages.free.description`),
      price: 0,
      sellingPoints: i18n.t(`${tRef}.packages.free.sellingPoints`, {
        returnObjects: true,
      }),
      variant: variant,
      packageCTA: i18n.t(`${tRef}.packages.free.cta`),
    }),
    [i18n, variant]
  )

  const standardPackage: PurchaseCardProps = useMemo(
    () => ({
      packageName: i18n.t(`${tRef}.packages.standard.name`),
      packageDescription: i18n.t(`${tRef}.packages.standard.description`),
      price: 139,
      affirmPrice: 48,
      sellingPoints: i18n.t(`${tRef}.packages.standard.sellingPoints`, {
        returnObjects: true,
      }),
      slug: 'standard',
      planDetails: {
        monthlyPrice: 75,
        monthlyInstallment: 2,
        id: 1,
      },
      variant: variant,
      packageCTA: i18n.t(`${tRef}.packages.standard.cta`),
      purchasePath: '/purchase/r6qVRv7',
    }),
    [i18n, variant]
  )

  const proPackage: PurchaseCardProps = useMemo(
    () => ({
      packageName: i18n.t(`${tRef}.packages.pro.name`),
      packageDescription: i18n.t(`${tRef}.packages.pro.description`),
      price: 189,
      affirmPrice: 65,
      sellingPoints: i18n.t(`${tRef}.packages.pro.sellingPoints`, {
        returnObjects: true,
      }),
      slug: 'pro',
      planDetails: {
        monthlyPrice: 99,
        monthlyInstallment: 2,
        id: 2,
      },
      mostPopular: true,
      variant: variant,
      packageCTA: i18n.t(`${tRef}.packages.pro.cta`),
      purchasePath: '/purchase/ramFE6X',
    }),
    [i18n, variant]
  )

  const elitePackage: PurchaseCardProps = useMemo(
    () => ({
      packageName: i18n.t(`${tRef}.packages.elite.name`),
      packageDescription: i18n.t(`${tRef}.packages.elite.description`),
      price: 299,
      affirmPrice: 27,
      sellingPoints: i18n.t(`${tRef}.packages.elite.sellingPoints`, {
        returnObjects: true,
      }),
      slug: 'elite',
      planDetails: {
        monthlyPrice: 85,
        monthlyInstallment: 4,
        id: 3,
      },
      variant: variant,
      packageCTA: i18n.t(`${tRef}.packages.elite.cta`),
      purchasePath: '/purchase/mRAeJG8',
    }),
    [i18n, variant]
  )

  const executivePackage: PurchaseCardProps = useMemo(
    () => ({
      packageName: i18n.t(`${tRef}.packages.executive.name`),
      packageDescription: i18n.t(`${tRef}.packages.executive.description`),
      price: 899,
      affirmPrice: 77,
      sellingPoints: i18n.t(`${tRef}.packages.executive.sellingPoints`, {
        returnObjects: true,
      }),
      slug: 'executive',
      planDetails: {
        monthlyPrice: 212,
        monthlyInstallment: 4,
        id: 4,
      },
      variant: variant,
      packageCTA: i18n.t(`${tRef}.packages.executive.cta`),
      purchasePath: '/purchase/B0qd82z',
    }),
    [i18n, variant]
  )

  const executiveExpandedPackage: PurchaseCardProps = useMemo(
    () => ({
      packageName: i18n.t(`${tRef}.packages.executive.name`),
      packageDescription: i18n.t(`${tRef}.packages.executive.description`),
      price: 899,
      affirmPrice: 77,
      sellingPoints: i18n.t(
        `${tRef}.packages.executiveExpanded.sellingPoints`,
        {
          returnObjects: true,
        }
      ),
      slug: 'executive',
      planDetails: {
        monthlyPrice: 212,
        monthlyInstallment: 4,
        id: 4,
      },
      variant: variant,
      packageCTA: i18n.t(`${tRef}.packages.executive.cta`),
      purchasePath: '/purchase/B0qd82z',
    }),
    [i18n, variant]
  )

  return useMemo(
    () => ({
      reviewPackage,
      standardPackage,
      proPackage,
      elitePackage,
      executivePackage,
      executiveExpandedPackage,
    }),
    [
      reviewPackage,
      standardPackage,
      proPackage,
      elitePackage,
      executivePackage,
      executiveExpandedPackage,
    ]
  )
}
